import React, { Component } from 'react';
import Axios from 'axios';
import { spinnerService } from '../../shared/services/spinner.service';
import ROUTES from '../../shared/constants/routes';
import CONFIG from '../../configuration';
import { setData, removeData } from '../../shared/utils/storage.util';
import { getRoleBasedRoute } from '../../shared/utils/helper.util';
import { msalInstance, loginRequest } from '../../shared/config/msalConfig';

class LoginComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ssoLoading: false,
            ssoError: null
        };
    }

    componentDidMount() {
        removeData('role');
    }

    handleSSOLogin = async () => {
        this.setState({ ssoLoading: true, ssoError: null });

        try {
            const loginResponse = await msalInstance.loginPopup(loginRequest);
            const idToken = loginResponse.idToken;

            spinnerService.show('Oval', 'Verifying Access');

            const response = await Axios.post(
                CONFIG.ssoLogin,
                { idToken },
                { headers: { 'Content-Type': 'application/json', language: 'en' } }
            );

            spinnerService.hide('Oval');

            if (response.data.responseCode === 200 && response.data.success) {
                const { role_name } = response.data.response.result;
                const loginData = { userData: response.data.response.result };
                setData('auth', response.data.response.result.token);
                setData('isLogin', true);
                setData('loginData', loginData);
                setData('token', response.data.response.result.token);
                setData(role_name, true);

                let route = getRoleBasedRoute();
                this.props.history.push(route);
            } else if (response.data.responseCode === 403) {
                this.props.history.push(ROUTES.NO_ACCESS);
            } else {
                this.setState({ ssoError: response.data.message || 'Login failed.' });
            }
        } catch (error) {
            spinnerService.hide('Oval');
            if (error.errorCode) {
                if (error.errorCode !== 'user_cancelled') {
                    this.setState({ ssoError: 'SSO login failed. Please try again.' });
                }
            } else {
                if (error.response && error.response.data && error.response.data.responseCode === 403) {
                    this.props.history.push(ROUTES.NO_ACCESS);
                } else {
                    this.setState({ ssoError: 'Unable to verify access. Please try again.' });
                }
            }
        } finally {
            this.setState({ ssoLoading: false });
        }
    };

    render() {
        return (
            <div className="login-main">
                <a href="" onClick={(e) => e.preventDefault()} className="login-logo testCICDAGAIN">
                    <img
                        src={require('../../assets/images/niagara-logo-color-2-x.png')}
                        alt="Login Logo"
                    />
                </a>
                <div className="login-form-container">
                    {this.state.ssoError && (
                        <div className="sso-error-message">
                            <p>{this.state.ssoError}</p>
                        </div>
                    )}
                    <div className="login-btn">
                        <button
                            className="btn-prmry"
                            onClick={this.handleSSOLogin}
                            disabled={this.state.ssoLoading}>
                            {this.state.ssoLoading ? 'Signing in...' : 'Sign in with Niagara SSO'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default LoginComponent;
